import React from 'react'

export function ArrowHeader({ width = '10', height = '5' }) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
      <rect width="10" height="5" transform="translate(10 5) rotate(-180)" fill="white" />
      <rect
        width="6.40312"
        height="1.60078"
        rx="0.80039"
        transform="matrix(-0.780869 0.624695 -0.780869 -0.624695 10 1)"
        fill="#039BE6"
      />
      <path
        d="M0.625 0.5C0.970178 0.223858 1.52982 0.223858 1.875 0.5L5.625 3.5C5.97018 3.77614 5.97018 4.22386 5.625 4.5C5.27982 4.77614 4.72018 4.77614 4.375 4.5L0.625 1.5C0.279822 1.22386 0.279822 0.776142 0.625 0.5Z"
        fill="#039BE6"
      />
    </svg>
  )
}
